import React from "react";
import { AuthProvider } from "./auth/AuthProvider";
import { ErrorBoundary } from "./components/common/ErrorBoundary";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { TaskPaneLayout } from "./components/layout/TaskPaneLayout";
import { HomePage } from "./pages/HomePage";

export function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ProtectedRoute>
          <TaskPaneLayout>
            <HomePage />
          </TaskPaneLayout>
        </ProtectedRoute>
      </AuthProvider>
    </ErrorBoundary>
  );
}
